var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.active === 0)?_c('div',[_c('steps-one',{attrs:{"type":_vm.type}})],1):_vm._e(),(_vm.active === 1)?_c('div',[_c('steps-two',{attrs:{"type":_vm.type}})],1):_vm._e(),(_vm.active === 2)?_c('div',[_c('steps-four',{attrs:{"type":_vm.type}})],1):_vm._e(),(_vm.active === 3)?_c('div',[_c('steps-five',{attrs:{"type":_vm.type}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }